import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from './utils/http'

// import Vue from 'vue'
// import BaiduMap from 'vue-baidu-map'

// Vue.use(BaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: 'IwatH8ut7ZyMQGy5PNWQ2v7tRYovMadB'
// })
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { BackTop,Affix,Button, Menu, MenuItem, Card, Row, Col, Tag, Tabs, TabPane, Form, FormItem, Input, CheckboxGroup, Checkbox, Select, Option, RadioGroup, Radio, Cascader } from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.component('Button', Button);
Vue.component('Menu', Menu);
Vue.component('MenuItem', MenuItem);
Vue.component('Card', Card);
Vue.component('Row', Row);
Vue.component('Col', Col);
Vue.component('Tag', Tag);
Vue.component('Tabs', Tabs);
Vue.component('TabPane', TabPane);
Vue.component('Form', Form);
Vue.component('FormItem', FormItem);
Vue.component('Input', Input);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Checkbox', Checkbox);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('RadioGroup', RadioGroup);
Vue.component('Radio', Radio);
Vue.component('Cascader', Cascader);
Vue.component('BackTop', BackTop);
Vue.component('Affix', Affix);
// import BaiduMap from 'vue-baidu-map'
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.axios = axios

// Vue.use(BaiduMap, {
//   ak: 'IwatH8ut7ZyMQGy5PNWQ2v7tRYovMadB'
// })
new Vue({router,
  render: h => h(App),
}).$mount('#app')
